import { hasCapability, type User } from "../base";

export const reviewRevenueAutoComplete = {
  read: (user: User) => hasCapability(user, "reviewRevenueAutoComplete.read"),
  update: (user: User) => hasCapability(user, "reviewRevenueAutoComplete.update"),
};
